import { apiClient } from '@store/index';
import { axiosErrorMiddleware } from './common';

type CreateService = {
  service_name: string;
  service_id: string;
  service_path: string;
  user_id: string;
};

export const createService = async ({ service_name, service_path, service_id, user_id }: CreateService) => {
  try {
    const response = await apiClient.post(`/workspaces`, {
      service_id,
      service_name,
      service_path,
      user_id,
    });

    if (response?.data) return response?.data;
    return { error: 'An unexpected error occured.' };
    return [];
  } catch (error) {
    return axiosErrorMiddleware(error);
  }
};

export const deleteService = async ({ id }: { id: string }) => {
  try {
    const response = await apiClient.delete(`/workspaces?id=${id}`);
    if (response?.data) return response?.data;
    return { error: 'An unexpected error occured.' };
  } catch (error) {
    return axiosErrorMiddleware(error);
  }
};
